@if (variantParentId()) {
    <!-- Price Reference Mode Header -->
    <div
        class="flex items-center gap-2 w-full bg-primary-50 dark:bg-primary-900/20 p-2 rounded-md border border-primary-200 dark:border-primary-800"
    >
        <i
            class="fas fa-link text-primary-600 dark:text-primary-400"
            [attr.data-testid]="'formly-unit-conversion-config-link-list-widget-fas-fa-link'"
        ></i>
        <span class="text-primary-700 dark:text-primary-300 font-medium text-sm">
            {{ 'product.unit-conversion-of' | translate }}
            <a
                class="underline hover:text-primary-800 dark:hover:text-primary-200 transition-colors"
                [routerLink]="['/products/edit', variantParentId()]"
                [attr.data-product-id]="variantParentId()"
                [attr.data-testid]="'formly-product-customer-product-price-edit-widget-a'"
            >
                {{ variantParentIdentifier() }}
            </a>
        </span>
    </div>
}
<div class="flex flex-col w-full">
    <app-base-list-wrapper [baseListComponent]="this">
        <ng-template #preColHeaders>
            <th [style.width.px]="10"></th>
        </ng-template>
        <ng-template #preCols let-rowData="rowData">
            <td>
                @if (rowData?.isGlobal) {
                    <i
                        class="fa-solid fa-globe"
                        [pTooltip]="'product.unit-conversion-global' | translate"
                    ></i>
                } @else if (rowData?.vendorPriceListAddressLinkId) {
                    <i
                        class="fa-solid fa-shopping-cart"
                        [pTooltip]="
                            'product.unit-conversion-vendor-price-list-address-link' | translate
                        "
                    ></i>
                } @else if (rowData?.productId) {
                    <i
                        class="fa-solid fa-box"
                        [pTooltip]="'product.unit-conversion-product' | translate"
                    ></i>
                }
            </td>
        </ng-template>
        <ng-template #preColsFilter>
            <th></th>
        </ng-template>
        <ng-template #moreButtons>
            <p-message severity="info" class="ms-2">
                <span class="text-lg">
                    {{ 'product.unit-conversion-formula' | translate }}
                </span>
            </p-message>
        </ng-template>
    </app-base-list-wrapper>
</div>
